(function($) {

	$(function() {

        /* Added Dec 14, 2020 -- When the "Add to Cart" button is clicked on the products page. */
        /*
        $('.product-submit').on('click',function(){

           window.alert("Hello!");

        })
        */
      
		Calculator = {

			GetCustomFields: function() {

				var capturedFields = $.Deferred();
				var fields = {};
				$('.ProductOtherDetails .DetailRow').each(function(i,v) {
					var key = $(v).children('.Label').text().toLowerCase().replace(/([~!@#$%^&*()_+=`{}\[\]\|\\:;'<>,.\/? ])+/g, "");
					var value = $.trim($(v).children('.Value').text());
					fields[key] = value;
				});

				capturedFields.resolve(fields);
				return capturedFields.promise();
			},

			GetCalculatorData: function( fields ) {

				var capturedData = $.Deferred();
				var data = {};
				data.boxPrice = 0;

				if ($('[data-box-price]').children().length > 0) {
					data.boxPrice = parseFloat(
						$('[data-box-price]')
							.data('box-price')
							.match(/\$([0-9]+[\.]*[0-9]*)/)[1]
					);
				}

				if ($('[data-strike-price]').children().length > 0) {
					data.strikePrice = parseFloat(
						$('[data-strike-price]')
							.data('strike-price')
							.replace('<strike>', '')
							.replace('</strike>', '')
							.match(/\$([0-9]+[\.]*[0-9]*)/)[1]
					);
				}

				if ($('.EnterSQF input[type=text]').length > 0) {
					if ($('.EnterSQF input[type=text]').val() != '') {
						data.sqf = parseFloat($('.EnterSQF input[type=text]').val());
					}
				}

				if ($('.calc-toggle span').length > 0 && $('.calc-toggle span').hasClass('on')) {
					data.includeWaste = true;
				} else {
					data.includeWaste = false;
				}

				if ('sqfperbox' in fields) {
					data.sqfPerBox = parseFloat(fields.sqfperbox);
				}

				data.sqfPrice = + parseFloat(data.boxPrice / data.sqfPerBox).toFixed(2);
				data.sqfStrikePrice = + parseFloat(data.strikePrice / data.sqfPerBox).toFixed(2);

				capturedData.resolve(data);
				return capturedData.promise();
			},

			CalculateSQF: function( data ) {

  			var calculateSQF = $.Deferred();

  			if (data.includeWaste) {
    			data.totalWaste = + parseFloat(data.sqf * 0.08).toFixed(3);
					data.sqf = parseFloat(data.sqf * 1.08).toFixed(3);
    		} else {
      		data.totalWaste = 0;
    		}

    		if ('sqf' in data && 'sqfPerBox' in data) {
    		  data.totalBoxes = Math.ceil(data.sqf / data.sqfPerBox);
    		  $('#productDetailsAddToCartForm input[name="qty[]"]').val(data.totalBoxes);
              $('.product-form-grid--quantity-true input[name="quantity"]').val(data.totalBoxes);
					data.sqf = parseFloat(data.sqfPerBox * data.totalBoxes).toFixed(3);
				}

				calculateSQF.resolve(data);
				return calculateSQF.promise();
			},

			CalculateShipping: function( data ) {

				var calculatedShipping = $.Deferred();

				calculatedShipping.resolve(data);
				return calculatedShipping.promise();
			},

			CalculateTotalCost: function ( data ) {

				var calculatedTotal = $.Deferred();

				data.subTotal = data.totalBoxes * data.boxPrice;

				if ("totalShipping" in data) {
					data.subTotal += data.totalShipping;
				}

				calculatedTotal.resolve(data);
				return calculatedTotal.promise();
			},

			DisplayResults: function( data ) {
				console.log('price data', data);
				if ('sqf' in data) {
					$('.ProductSummary .totalsqf span').text(Number(data.sqf));
				}

				if ('totalBoxes' in data) {
					if (data.totalBoxes > 1) {
						$('.ProductSummary .totalbox').text(data.totalBoxes + " Boxes");
					} else {
						$('.ProductSummary .totalbox').text(data.totalBoxes + " Box");
					}
				}

              
				// display price per sqf
				if ('sqfPrice' in data) {
					$('.ProductSummary .sqf span').text("$" + data.sqfPrice);
				}

				// display price per box
				if ('boxPrice' in data) {
					$('.ProductSummary .box span').text("$" + data.boxPrice);
				}

				// display waste
				if ('totalWaste' in data) {
					$('.ProductSummary .waste span').text(data.totalWaste);
				}



				// display subtotal
				if ('subTotal' in data) {
					$('.ordertotal').html("Total: $" + data.subTotal.toFixed(2));
					
					// Modification - July 29th, 2016 MG
					var shippingQualifyMsg = false;
					if(data.subTotal <= 1500)
						// shippingQualifyMsg = '$189 free shipping when ordering 4 or more boxes';
                      shippingQualifyMsg = '';
					else
					//	shippingQualifyMsg = '<span class="shipping_qualify_congrats">Congratulations ! </span><span class="shipping_qualify_text">You got free shipping from $189.</span>';
					shippingQualifyMsg = '';
                      // End Modification - July 29th, 2016 MG
					
					if(shippingQualifyMsg != false) {
						$('.shipping_qualify').html(shippingQualifyMsg);
					}
				}

				if ( data.totalBoxes >= 4) {
					//$('.shipping_qualify').html('<span class="shipping_qualify_congrats">Congratulations ! </span><span class="shipping_qualify_text">You got free shipping from $189.</span>');
				$('.shipping_qualify').html('');
                }

				$('.ProductSummary').css({'visibility': 'visible','display': 'block'});
				$('.ProductSummaryPrice').css({'visibility': 'visible'});

			},

			Calculate: function() {
				Calculator.GetCustomFields()
					.pipe(Calculator.GetCalculatorData)
					.pipe(Calculator.CalculateSQF)
					.pipe(Calculator.CalculateShipping)
					.pipe(Calculator.CalculateTotalCost)
					.pipe(Calculator.DisplayResults);
			},

			ReplacePrice: function() {
				Calculator.GetCustomFields()
					.pipe(Calculator.GetCalculatorData)
					.done(function(data) {
						if ('sqfPrice' in data) {
							$('.PriceRow .VariationProductPrice span').text("$" + data.sqfPrice);
							$('.PriceRow .VariationProductPrice').css({'visibility':'visible'});
						}
						if ('sqfStrikePrice' in data) {
							$('.PriceRow .retail-product-price strike').text("$" + data.sqfStrikePrice);
							$('.PriceRow .retail-product-price').css({'visibility':'visible'});
						}
				});
			},

			Reset: function() {
				$('.EnterSQF input').val(null);
				$('.EnterZipCode input').val(null);

				if ($(".toggle").hasClass('on')) {
					$(".toggle").removeClass('on').html('no');
				}

				$('.ProductSummary').css({'visibility': 'hidden'});
				$('.ProductSummaryPrice').text('').css({'visibility': 'hidden'});
			}
		};

		// replace box price with sqf price
		Calculator.ReplacePrice();

		// reset inputs and display
		Calculator.Reset();

		var timeout = null;
		var lastSqf = null;

		// bind sqf input
		$('.EnterSQF input[type=text]').keypress(function (e) {

			if (timeout) clearTimeout(timeout);

			if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
				return false;
			}

		}).keyup(function (e) {

			var sqf = parseFloat($(this).val()) || 0;

			if (timeout) clearTimeout(timeout);
			timeout = setTimeout(function () {
				if (sqf > 0) {
					if (sqf != lastSqf) {
                		Calculator.Calculate();
                		lastSqf = sqf;
                	}
				} else {
					lastSqf = sqf;
					Calculator.Reset();
				}
			}, 500);
		});

		// bind toggle.
		$('.calc-toggle').toggle(function () {
			$(".toggle").addClass('on').html('yes');
			if (parseInt($('.EnterSQF input[type=text]').val()) > 0) {
				Calculator.Calculate();
			}
		}, function () {
			$(".toggle").removeClass('on').html('no');
			if (parseInt($('.EnterSQF input[type=text]').val()) > 0) {
				Calculator.Calculate();
			}
		});

		// hide custom fields block
		$('.ProductOtherDetails').css({'display': 'none'});

		// bind add to cart button
		$('#productDetailsAddToCartForm .AddCartWrap')
			.mouseenter(function() {
				if (!($('.EnterSQF input[type=text]').val() > 0)) {
					$(this).children('.AddCartButton').val('Enter Your SQF Above');
				}
			}).mouseleave(function() {
				$(this).children('.AddCartButton').val('Add To Cart');
			}).click(function() {

			let totalValue = parseFloat($('.ordertotal').text().split('$').pop());
			// console.log('totalValue', totalValue);
			pintrk('track', 'addtocart', {value: totalValue, order_quantity: 1});

  			$('#productDetailsAddToCartForm').submit();
  		});

		$('#productDetailsAddToCartForm .AddCartWrap .AddCartButton').click(function(e) {
  		e.preventDefault();
		})

		// override add to cart form submission
		$('#productDetailsAddToCartForm').die('submit');
		$('#productDetailsAddToCartForm').removeAttr('onSubmit');
		$('#productDetailsAddToCartForm').submit(function (e) {

			e.preventDefault();
			if ($('.EnterSQF input[type=text]').val() > 0 && $('#productDetailsAddToCartForm input[name="qty[]"]').val() > 0) {
				if (check_add_to_cart(this, false)) {
					this.submit();
				};
			}
		});

	});
})(window.jQuery)